import { useMemo, useState } from 'react';

import { observer } from 'mobx-react-lite';

import { Button } from '@components/button';
import { SelectMulti } from '@components/selectmulti';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { sortByObjectKey } from '@utils/collections';

import { Loading } from 'components/Loading';
import ShowMore from 'components/ShowMore';
import { Modal } from 'features/modals';
import { useStore } from 'models/Provider';

import { GrantList } from './styles';

function GrantMultipleModal({ job, applicants, closeModal }) {
  const [selected, setSelected] = useState([]);
  const [saving, setSaving] = useState(false);
  const { userStore, t } = useStore();

  async function addUsersToApplications() {
    setSaving(true);
    const success = await job.bulkGrantAccess(
      applicants,
      selected.map((u) => userStore.items.get(u.value))
    );
    setSaving(false);
    if (success) {
      closeModal();
    }
  }

  const assignableUsers = useMemo(() => {
    return sortByObjectKey(
      userStore.list.filter((user) => !(user.role === 'user' || job.followers.includes(user))),
      'name'
    ).map((user) => ({
      label: user.name,
      value: user.id,
      helpText: user.roleDisplay,
    }));
  }, [userStore.list, job.followers]);

  return (
    <Modal>
      <Modal.Header text={t('modals.grantmulti.heading')} />

      {saving && <Loading />}
      <Stack space={4}>
        <Text text={t('modals.grantmulti.applicantsmsg')} />
        <ShowMore
          max={applicants.length}
          count={applicants.length > 10 ? 5 : applicants.length}
          inc={1000}
          render={({ count }) => (
            <GrantList>
              {applicants.slice(0, count).map((a, i) => (
                <div key={i}>{a.name}</div>
              ))}
            </GrantList>
          )}
        />

        <SelectMulti
          placeholder={t('modals.grantmulti.users.select')}
          label={t('modals.grantmulti.label')}
          options={assignableUsers}
          onChange={setSelected}
        />
      </Stack>

      <Modal.Actions>
        <Button
          variant="secondary"
          onClick={closeModal}
          isDisabled={saving}
          text={t('modals.grantmulti.button.cancel')}
        />
        <Button
          onClick={saving || selected.length === 0 ? null : addUsersToApplications}
          isDisabled={saving || selected.length === 0}
          text={t('modals.grantmulti.button.submit')}
        />
      </Modal.Actions>
    </Modal>
  );
}

export default observer(GrantMultipleModal);
